import { Outlet } from "react-router-dom";

const Workspace: React.FC = () => {
    return <Outlet />;
};

export default Workspace;
